<template>
    <div>
        <Multiselect v-model="selectedDepartments" :options="options" :multiple="true" placeholder="Select Department"
            track-by="departmentId" :clear-on-select="false" :show-labels="false" label="name" :preselect-first="true">
        </Multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'departmentsDropdown',
    props: {
        modelValue: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Multiselect,
    },
    data() {
        return {
            selectedDepartments: [], 
            options: [],
        };
    },
    watch: {
        selectedDepartments(newVal) {
            const transformedData = newVal.map(x => ({
                id:x.id,
                departmentId: x.departmentId,
                name: x.name, 
                userId: localStorage.getItem("UserID")
            }));
            this.$emit('update:modelValue', transformedData);
        }
    },
    methods: {
        getData: function () {
            var root = this;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }

            root.$https.get('/Department/GetDepartmentsList?isDropDown=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                if (response.data && response.data.results) {
                    root.options = response.data.results.map(cat => ({
                        departmentId: cat.id,
                        name: cat.name || '', 
                    }));
                    // Initialize selectedDepartments if modelValue is already populated
                    root.selectedDepartments = root.modelValue.map(service => {
                        const matchedOption = root.options.find(option => option.departmentId === service.departmentId);
                        return matchedOption
                            ? { ...service, name: matchedOption.name }
                            : service;
                    });
                }
            });
        },
    },
    mounted: function () {
        this.getData();
    },
}
</script>